import * as TYPE from './mutation-type.js';

export default {
  [TYPE.SET_USER_INFO](state, info) {
    state.userInfo = info;
  },
  [TYPE.UPD_USER_INFO](state, info) {
    state.userInfo = { ...state.userInfo, ...info };
  },
  [TYPE.SET_SHOP_ITEMS](state, data) {
    state.shopItems = data;
  },
  [TYPE.SET_PROVIDER_ITEMS](state, data) {
    state.providerItems = data;
  },
  [TYPE.SET_ADD_LIST](state, data) {
    state.addressList = data;
  },
  [TYPE.SET_ADDRESS_ID](state, id) {
    state.addressId = id;
  },
  [TYPE.SET_RX_SHADE_CONFIG](state, data) {
    state.rxShadeConfig = data;
  }
};
